import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { IAppState, ApiRequest } from "../../Common";
import { endpoints } from "..";

import { Feedback } from "../Models/Feedback";
import { ResponseResult } from "../../Common/Models/ResponseResult";
import ResponseHandler from "../../App/ResponseHandler";

export interface ActionBase {
  type: FeedbackEditActionTypes;
}

export interface Action<Payload> extends ActionBase {
  payload: Payload | null;
}

export enum FeedbackEditActionTypes {
  SET_FEEDBACK = "FEEDBACK_EDIT_SET_FEEDBACK",
  RESET_LOADING = "FEEDBACK_EDIT_RESET_LOADING",
  SET_LOADING = "FEEDBACK_EDIT_SET_LOADING",
  RESET_LOADED = "FEEDBACK_EDIT_RESET_LOADED",
  SET_ERROR = "FEEDBACK_EDIT_SET_ERROR"
}

export const setFeedback = (feedback: Feedback): Action<Feedback> => {
  return {
    type: FeedbackEditActionTypes.SET_FEEDBACK,
    payload: feedback
  };
};

export const setLoading = (): ActionBase => {
  return {
    type: FeedbackEditActionTypes.SET_LOADING
  };
};

export const resetLoading = (): ActionBase => {
  return {
    type: FeedbackEditActionTypes.RESET_LOADING
  };
};

export const resetLoaded = (): ActionBase => {
  return {
    type: FeedbackEditActionTypes.RESET_LOADED
  };
};

const setError = (errorCode: number, errorDescription: string): Action<any> => {
  return {
    type: FeedbackEditActionTypes.SET_ERROR,
    payload: {
      errorCode,
      errorDescription
    }
  };
};

export const getFeedback = (
  code: string
): ThunkAction<Promise<void>, IAppState, {}, Action<any>> => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<any> => {
    const url: string = endpoints.feedback.getByCode(code);

    ApiRequest.fromPath(url)
      .withAuthHeader()
      .get()
      .then((response: Response) => {
        ResponseHandler.handle(
          response,
          (result: ResponseResult) => {
            dispatch(setFeedback(result.payload));
          },
          (result: ResponseResult) => {
            dispatch(setError(response.status, result.error.message));
          },
          () => {
            dispatch(setError(response.status, "An unknown error has occured"));
          }
        );
      });
  };
};
